import React, { Component } from 'react';

const EblastRDR = () => {
	return ( <h1>Eblast RDRs</h1> );
}
 
export default EblastRDR;